// eslint-disable-next-line jira/restricted/@atlassian/jira-router
import { createResource } from '@atlassian/jira-router';

export const RESOURCE_TYPE_DEVOPS_CONNECTIONS_PERMISSIONS =
	'RESOURCE_TYPE_DEVOPS_CONNECTIONS_PERMISSIONS';

export const connectionsPermissionsResource = createResource<{
	canCreateAndEditIssues: boolean;
	canBrowseProjects: boolean;
}>({
	type: RESOURCE_TYPE_DEVOPS_CONNECTIONS_PERMISSIONS,
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-connections", jiraSpaEntry: "async-resource-connections" */ './get-data'
		),
	isBrowserOnly: true,
	maxAge: 1800000, // 30 minutes
});
